var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-header'),_c('div',{staticStyle:{"min-height":"100vh"}},[_c('zoom-center-transition',{attrs:{"duration":400,"mode":"out-in"}},[_c('router-view')],1)],1),_c('my-footer'),_c('tabbar'),_c('mobile-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }